import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from 'src/app/services/security.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-call-back',
    templateUrl: './call-back.component.html',
    styleUrls: ['./call-back.component.scss'],
    standalone: false
})
export class CallBackComponent implements OnInit {

  constructor(private authService: SsoSecurityService,private router:Router,private userservice:UserService) { }


  ngOnInit() {
    this.userservice.resetUnauthorized();
    
    this.authService.completeAuthentication().then(result=>{
     console.log(result)
      this.router.navigate(['auth-home']);
  
    });
 

}

}